module.exports = __webpack_public_path__ + "img/banner_video.58ae4a35.png";